import TPBPageWrapper from './TPBPageWrapper.component';

export default TPBPageWrapper;
